var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageIcon = function SvgMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#251628",
    d: "M26.25.798H3.15C1.413.798 0 2.095 0 3.688v15.414c0 1.594 1.413 2.89 3.15 2.89h23.1c1.737 0 3.15-1.296 3.15-2.89V3.688c0-1.593-1.413-2.89-3.15-2.89m1.05 18.304c0 .531-.472.964-1.05.964H3.15c-.578 0-1.05-.433-1.05-.964V3.688c0-.53.472-.963 1.05-.963h23.1c.578 0 1.05.432 1.05.963zM25.037 5.101c.31.45.164 1.044-.326 1.328l-8.337 4.833a3.37 3.37 0 0 1-1.676.439 3.36 3.36 0 0 1-1.667-.436L4.69 6.43c-.49-.284-.637-.88-.327-1.329.31-.45.958-.583 1.448-.3l8.337 4.834c.334.19.77.19 1.109-.003l8.333-4.83c.49-.285 1.137-.151 1.447.3"
  })));
};
export default SvgMessageIcon;